const CameraEventTypes = {
    CAMERA_CHANGED: "CAMERA_CHANGED"
}

const ViewerEventTypes = {
    VIEWER_RESIZED: "VIEWER_RESIZED",
    VIEWER_DIRECTION_CHANGED: "VIEWER_DIRECTION_CHANGED",
    VIEWER_FOV_CHANGED: "VIEWER_FOV_CHANGED",
    VIEW_CLICKED: "VIEW_CLICKED",
    POINT3D_CLICKED: "POINT3D_CLICKED",
    VOLUME_TAG_CHANGED: "VOLUME_TAG_CHANGED",
    VIEW_HIGHLIGHTED: "VIEW_HIGHLIGHTED",
    LABEL_SELECTION: "LABEL_SELECTION",
    ANNOTATION_UPDATE: "ANNOTATION_UPDATE"
}

const BoxManagerEventTypes = {
    BOX_CHANGED: "BOX_CHANGED"
}

var ViewerEvents = {
    Camera: CameraEventTypes,
    Viewer: ViewerEventTypes,
    BoxManager: BoxManagerEventTypes
};

export default ViewerEvents;